const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

const BASE_URL = process.env.REACT_APP_BASE_URL

export type UserData = {
    username: string;
    password: string | null;
    firstname: string;
    lastname: string;
    email: string;
    mobilenumber: string;
    nic: string;
    address: string;
    country: string;
    organization: string;
    department: string;
    role: string;
    profilePicUrl: string | null;
    themecolorbconex: string;
    thememodebconex: string;
    thememodeeaglei: string;
    isAllCountry: boolean | null;
    accessprivileges: string[];
    specificAreas: string[];
    policies: string[];
    id: string | null;
}

export const APIGetAllUsers = async (): Promise<{status: boolean, data: UserData[], message: string}> => {
    const URL: string = `${BASE_URL}/identity_manager/api/v1/getallusers`
    const HEADER: RequestInit = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        }
    }

    const response = await fetch(URL, HEADER)
    const responseData: UserData[] = await response.json() as UserData[]

    if (response.status !== 200)
    {
        return {status: false, data: [], message: 'data getting failed'}
    }
    return {status: true, data: responseData, message: 'users getting successfully'}
}

export type ResponseTypes = {
    message: string;
    httpStatus: string;
    data?: any;
    errorCode?: number;
    errorMessage?: number;
    access_token?: string
}

export type ResponseUserRole = {
    roleid: string
    rolename: string
    roledescription: string
    roleAreaSpecificity: string
}

export const APIGetAllRoles = async (): Promise<{status: boolean, data: ResponseUserRole[], message: string}> => {
    const URL: string = `${BASE_URL}/identity_manager/api/v1/getallroles`
    const HEADER: RequestInit = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        }
    }

    const response = await fetch(URL, HEADER)
    const responseData: ResponseUserRole[] = await response.json() as ResponseUserRole[]

    if (response.status !== 200)
    {
        return {status: false, data: [], message: 'use role getting failed'}
    }
    return {status: true, data: responseData, message: 'user role getting successfully'}
}

export type IncidentInformDataType = {
    incidentType: string
    usernames: string[]
    roles: string[]
    userSpecific: boolean
    roleSpecific: boolean
}

export const APIRequestUpdateIncidentInform = async (body: IncidentInformDataType): Promise<{status: boolean, message: string}> => {
    const URL: string = `${BASE_URL}/hz/api/v1/updateIncidentInformData`
    const HEADER: RequestInit = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
    }
    
    try
    {
        const response = await fetch(URL, HEADER)
        
        if (response.status !== 200)
        {
            return {status: false, message: 'use role getting failed'}
        }
        return {status: true, message: 'user role getting successfully'}
    }
    catch (ex)
    {
        console.error(`Error while submitting data with error [${ex}]`)
        return {status: false, message: 'use role getting failed'}
    }
}

export type RequestIncidentInfo = {
    type: string
}

export const APIRequestGetIncidentInform = async (body: RequestIncidentInfo): Promise<{status: boolean, data: IncidentInformDataType | null, message: string}> => {
    const URL: string = `${BASE_URL}/hz/api/v1/getIncidentInformData`
    const HEADER: RequestInit = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseData = await response.json() as ResponseTypes
        
        if (response.status !== 200)
        {
            return {status: false, data: null, message: 'incident info getting failed'}
        }
        return {status: true, data: responseData.data as IncidentInformDataType, message: 'user role getting successfully'}
    }
    catch (ex)
    {
        console.error(`Error while submitting data with error [${ex}]`)
        return {status: false, data: null, message: 'incident info getting failed'}
    }
}

export type ResponseIncidentPrivilege = {
    userSpecific: boolean
    roleSpecific: boolean
}

export const APIRequestGetIncidentPrivilege = async (body: RequestIncidentInfo): Promise<{status: boolean, data: ResponseIncidentPrivilege | null, message: string}> => {
    const URL: string = `${BASE_URL}/hz/api/v1/getIncidentPrivilegeData`
    const HEADER: RequestInit = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseData = await response.json() as ResponseTypes
        
        if (response.status !== 200)
        {
            return {status: false, data: null, message: 'incident info getting failed'}
        }
        return {status: true, data: responseData.data as ResponseIncidentPrivilege, message: 'incident privileges get successfully'}
    }
    catch (ex)
    {
        console.error(`Error while submitting data with error [${ex}]`)
        return {status: false, data: null, message: 'incident info getting failed'}
    }
}